import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import { LoadingSpinner } from "@/components/LoadingSpinner";

const PersonaInquiry = dynamic(() => import("persona-react"), { ssr: false });

interface IInlineInquiryProps {
    templateId?: string;
    inquiryId?: string;
    sessionToken?: string;
    language?: string;
}
export function InlineInquiry(props: IInlineInquiryProps) {
    const [isReady, setIsReady] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (typeof window === "undefined") return;

        const iframe = document.querySelector(
            'iframe[data-testid="persona-widget__iframe"]',
        ) as HTMLIFrameElement | null;
        if (isReady && iframe) {
            setLoading(false);
            iframe.style.width = "400px";
            iframe.style.height = "100vh";
        }
    }, [isReady]);

    return (
        <div className="flex w-full h-screen justify-center">
            {loading ? (
                <LoadingSpinner className="w-[75px] h-[75px] m-auto absolute top-[45%]" />
            ) : null}
            <PersonaInquiry
                templateId={
                    props.inquiryId
                        ? undefined
                        : props.templateId ||
                          process.env.NEXT_PUBLIC_PERSONA_TEMPLATE_ID
                }
                inquiryId={props.inquiryId ? props.inquiryId : undefined}
                environmentId={process.env.NEXT_PUBLIC_PERSONA_ENV_ID}
                language={props.language || "en"}
                onReady={() => {
                    setIsReady(true);
                }}
            />
        </div>
    );
}
